module.exports = __webpack_public_path__ + "921f1150167369cf4c400135a4905728.woff2";